import { getKybModel } from './kyb.service.ts';
import type { StateCreator } from 'zustand';
import type { IKybSlice, KybData } from './kyb.types.ts';

export const createKybSlice: StateCreator<IKybSlice> = (set, get) => ({
  kybData: getKybModel(),
  setKybData: (kybData: KybData) => {
    set(() => ({ kybData: kybData }));
  },
  getKybData: () => get().kybData,
  prevOnboardingStatus: null,
  setPrevOnboardingStatus: (status) => {
    set(() => ({ prevOnboardingStatus: status }));
  },
});
